import { useContext } from 'react';

import { type ToastContextType,ToastNotificationContext } from './toastNotifications.context';

export const useToastNotifications = (): ToastContextType => {
    const context = useContext(ToastNotificationContext);
    if (!context) {
        throw new Error('useToastNotifications must be used within a ToastProvider');
    }
    return context;
};
